import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["fill"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 20 20",
    fill: "none"
  }, [_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M15.8333 2.5H4.16667C3.25 2.5 2.50833 3.25 2.50833 4.16667L2.5 6.66667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 9.16667H9.16667V15.8333H7.5V9.16667H4.16667V7.5H7.5V4.16667H9.16667V7.5H15.8333V9.16667Z",
    fill: $props.color
  }, null, 8, _hoisted_2)], 8, _hoisted_1);
}